var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11104_110320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5821 10.4199H10.4242V33.5778H33.5821V10.4199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5758 44.0011L43.9968 33.5801H33.5758V44.0011Z",
    fill: "#D82A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9968 10.4199H33.5758V33.5778H43.9968V10.4199Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5821 33.5801H10.4242V44.0011H33.5821V33.5801Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5789V40.5262C0 42.4454 1.55447 43.9999 3.47368 43.9999H10.4211V33.5789H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9968 10.4211V3.47368C43.9968 1.55447 42.4424 0 40.5231 0H33.5758V10.4211H43.9968Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5789 0H3.47368C1.55447 0 0 1.55447 0 3.47368V33.5789H10.4211V10.4211H33.5789V0Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1723 28.387C14.3068 27.8023 13.7076 26.9484 13.3805 25.8194L15.3894 24.9915C15.5718 25.6863 15.8902 26.2247 16.3447 26.6068C16.7963 26.9889 17.3463 27.1771 17.9889 27.1771C18.646 27.1771 19.2105 26.9773 19.6823 26.5778C20.1542 26.1784 20.3915 25.6689 20.3915 25.0523C20.3915 24.4213 20.1426 23.906 19.6447 23.5065C19.1468 23.107 18.5215 22.9073 17.7747 22.9073H16.6139V20.9186H17.656C18.2986 20.9186 18.84 20.7449 19.28 20.3976C19.72 20.0502 19.94 19.5755 19.94 18.9705C19.94 18.432 19.7431 18.0036 19.3494 17.6823C18.9557 17.361 18.4579 17.1989 17.8529 17.1989C17.2623 17.1989 16.7934 17.3552 16.446 17.6707C16.0989 17.9871 15.8379 18.3865 15.6876 18.8315L13.6989 18.0036C13.9623 17.2568 14.4457 16.5968 15.155 16.0265C15.8642 15.4563 16.7702 15.1697 17.8702 15.1697C18.6836 15.1697 19.416 15.326 20.0644 15.6415C20.7129 15.957 21.2223 16.3942 21.59 16.9499C21.9576 17.5086 22.14 18.1339 22.14 18.8286C22.14 19.5378 21.9692 20.137 21.6276 20.6292C21.286 21.1213 20.8663 21.4976 20.3684 21.761V21.8797C21.0113 22.1447 21.5697 22.5801 21.9836 23.1389C22.4034 23.7034 22.6147 24.3778 22.6147 25.1652C22.6147 25.9526 22.415 26.656 22.0155 27.2726C21.616 27.8892 21.0631 28.3755 20.3626 28.7286C19.6592 29.0818 18.8689 29.2613 17.9918 29.2613C16.9757 29.2642 16.0379 28.9718 15.1723 28.387ZM27.5126 18.4176L25.3068 20.0126L24.2039 18.3394L28.161 15.4852H29.6778V28.9486H27.5126V18.4176Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11104_110320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.eae25c4e.svg";
export { ForwardRef as ReactComponent };